"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSavedBlockPlaceholderByType = void 0;
var block_video_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-video-placeholder.svg"));
var block_text_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-text-placeholder.svg"));
var block_splash_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-splash-placeholder.svg"));
var block_embed_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-embed-placeholder.svg"));
var block_quote_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-quote-placeholder.svg"));
var block_accept_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-accept-placeholder.svg"));
var block_agreement_placeholder_svg_1 = __importDefault(require("@ClientAssets/icons/block-agreement-placeholder.svg"));
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var getSavedBlockPlaceholderByType = function (type) {
    switch (type) {
        case BlockTypes_1.BlockType.Text:
            return block_text_placeholder_svg_1.default;
        case BlockTypes_1.BlockType.Video:
            return block_video_placeholder_svg_1.default;
        case BlockTypes_1.BlockType.OldQuote:
        case BlockTypes_1.BlockType.Quote:
            return block_quote_placeholder_svg_1.default;
        case BlockTypes_1.BlockType.Accept:
            return block_accept_placeholder_svg_1.default;
        case BlockTypes_1.BlockType.Source:
            return block_embed_placeholder_svg_1.default;
        case BlockTypes_1.BlockType.Splash:
            return block_splash_placeholder_svg_1.default;
        case BlockTypes_1.BlockType.Agreement:
            return block_agreement_placeholder_svg_1.default;
        case BlockTypes_1.BlockType.Browser:
        default:
            return block_text_placeholder_svg_1.default;
    }
};
exports.getSavedBlockPlaceholderByType = getSavedBlockPlaceholderByType;
